/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PaginatedPeerRatingList } from '../models/PaginatedPeerRatingList';
import type { PeerRating } from '../models/PeerRating';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class PeerRatingsService {

    /**
     * @returns PaginatedPeerRatingList
     * @throws ApiError
     */
    public static peerRatingsList({
        limit,
        offset,
    }: {
        /**
         * Number of results to return per page.
         */
        limit?: number,
        /**
         * The initial index from which to return the results.
         */
        offset?: number,
    }): CancelablePromise<PaginatedPeerRatingList> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/peer-ratings/',
            query: {
                'limit': limit,
                'offset': offset,
            },
        });
    }

    /**
     * @returns PeerRating
     * @throws ApiError
     */
    public static peerRatingsCreate({
        requestBody,
    }: {
        requestBody: PeerRating,
    }): CancelablePromise<PeerRating> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/peer-ratings/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

}
